import axios from 'axios';
import {
  accessToken,
  refreshToken,
  clearLocalStorage,
} from '../../utils/setLocalStorage';

// initial state
const authState = {
  token: null,
  timeout: null,
  loginError: false,
};

const mutations = {
  SET_ACCESS_TOKEN(state, token) {
    accessToken(token);
  },
  SET_ACCESS_TOKEN_TO_STORE(state, token) {
    state.token = token;
  },
  SET_REFRESH_TOKEN(state, token) {
    refreshToken(token);
  },
  SET_USER_INFO(state, user) {
    state.user = user;
  },
  CLEAR_LOCAL_STORAGE() {
    clearLocalStorage()
  },
  SET_LOGIN_ERROR(state, error) {
    state.loginError = error
  },
};

const actions = {
  POST_LOGIN({ commit, rootState }, userInfo) {
    commit('SET_LOGIN_ERROR', false)
    axios
      .post(`${rootState.api}/login`, {
        email: userInfo.email,
        password: userInfo.password,
      })
      .then((res) => {
        commit('SET_ACCESS_TOKEN', res.data.access_token);
        commit('SET_REFRESH_TOKEN', res.data.refresh_token);
        window.location.href = `${userInfo.redirect}`;
      })
      .catch(() => commit('SET_LOGIN_ERROR', true));
  },
  POST_LOGOUT({ commit, rootState }) {
    axios
      .post(`${rootState.api}/logout`)
      .then(() => {
        commit('CLEAR_LOCAL_STORAGE');
        window.location.href = '/';
      })
      .catch((error) => console.error(error));
  },
};

const authGetters = {
  userIsLogged(state, getters, rootState) {
    return rootState.user && !!rootState.user.details
  },
};

export default {
  namespaced: true,
  state: authState,
  getters: authGetters,
  actions,
  mutations,
};
